export const FeatureKeys = {
    // Core Event Management
    MaxActiveEvents: 'MaxActiveEvents',
    MaxAttendeesPerEvent: 'MaxAttendeesPerEvent',
    PrivateEventsEnabled: 'PrivateEventsEnabled',
    MultiSessionEventsEnabled: 'MultiSessionEventsEnabled',
    SessionCustomisationEnabled: 'SessionCustomisationEnabled',

    // Ticketing
    PaidTicketsEnabled: 'PaidTicketsEnabled',
    RefundsEnabled: 'RefundsEnabled',
    TicketBundlesEnabled: 'TicketBundlesEnabled',
    PromoCodesEnabled: 'PromoCodesEnabled',
    PayWhatYouCanEnabled: 'PayWhatYouCanEnabled',
    WaitlistsEnabled: 'WaitlistsEnabled',
    QRTicketCheckInEnabled: 'QRTicketCheckInEnabled',

    // Registration
    CustomRegistrationTemplates: 'CustomRegistrationTemplates',
    RequiresApprovalEnabled: 'RequiresApprovalEnabled',
    AttendeeVisibilityToggleEnabled: 'AttendeeVisibilityToggleEnabled',

    // Team & Collaboration
    MaxTeamMembers: 'MaxTeamMembers',
    EventCoordinatorsEnabled: 'EventCoordinatorsEnabled',
    TaskManagementEnabled: 'TaskManagementEnabled',
    FileSharingEnabled: 'FileSharingEnabled',

    // CRM & Delegates
    DelegateCRMEnabled: 'DelegateCRMEnabled',
    LocationCRMEnabled: 'LocationCRMEnabled',

    // Analytics
    EventAnalyticsEnabled: 'EventAnalyticsEnabled',
    LocationAnalyticsEnabled: 'LocationAnalyticsEnabled',
    DelegateAnalyticsEnabled: 'DelegateAnalyticsEnabled',
    DataExportsEnabled: 'DataExportsEnabled',
    EsgReportingEnabled: 'EsgReportingEnabled',

    // Finance
    FinanceTrackingEnabled: 'FinanceTrackingEnabled',
    AdvancedFinanceTrackingEnabled: 'AdvancedFinanceTrackingEnabled',
    CommunityHubEnabled: 'CommunityHubEnabled',

    // Communication
    CampaignManagementEnabled: 'CampaignManagementEnabled',
    MaxMarketingEmailsPerMonth: 'MaxMarketingEmailsPerMonth',
    CustomEmailTemplatesEnabled: 'CustomEmailTemplatesEnabled',
    MaxCustomEmailTemplates: 'MaxCustomEmailTemplates',
    CustomEmailLayoutsEnabled: 'CustomEmailLayoutsEnabled',
    EmailFormsEnabled: 'EmailFormsEnabled',
    CommsInboxEnabled: 'CommsInboxEnabled',

    // Embed
    EmbeddedEventRegistrationEnabled: 'EmbeddedEventRegistrationEnabled',

    // Branding
    CustomBrandingEnabled: 'CustomBrandingEnabled',
    WhiteLabelEnabled: 'WhiteLabelEnabled',
    CustomDomainEnabled: 'CustomDomainEnabled',
    BrandedEventsPlatformEnabled: 'BrandedEventsPlatformEnabled',

    // Advanced
    RoomsManagementEnabled: 'RoomsManagementEnabled',
    APIAccessEnabled: 'APIAccessEnabled',
    BulkOperationsEnabled: 'BulkOperationsEnabled',
    SSOEnabled: 'SSOEnabled',

    // Coming Soon
    AIEventAssistantEnabled: 'AIEventAssistantEnabled',
} as const;

export type FeatureKey = typeof FeatureKeys[keyof typeof FeatureKeys];
